import { createTheme } from '@mui/material/styles';

const defaultTheme = createTheme({
    palette: {
        primary: {
          main: '#0000ff', // Custom primary color
        },
        secondary: {
          main: '#FDFD96', // Custom secondary color
        },
        alwaysIcon: {
          main: '#F69C4E', // Custom color for "alwaysIcon"
          contrastText: '#ffffff', // Text color on the button
        },
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              '&.MuiButton-containedAlwaysIcon': {
                backgroundColor: '#F69C4E',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#e58938', // A darker shade for hover
                },
              },
            },
          },
        },
      },





  typography: {
    h6: {
      fontWeight: 'bold',
    },
  },
});

export default defaultTheme;


